import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {getTranslationLang} from '../../../../../i18n';
import styles from "./style.css";

import cacheManager from '../../../domain/services/StickerCache';
import { themesGroupsSelector } from "../../../store/dictionaries/selectors";
import {
  createLlamaStateSelector,
  createLlamaIdSelector,
  createStickerIdSelector, createStickerItemIdSelector
} from "../../../store/create-llama/selectors";
import {
  createLlamaActiveGroupThemesSelector,
  createLlamaActiveThemeSelector, createLlamaActiveThemesGroupSelector,
} from "../../../store/create-llama/selectors";
import {
  checkStepValidation,
  setTheme,
  setThemeGroup,
  setTextTemplatesGroup
} from "../../../store/create-llama/actions";
import HorizontalSwitch from "../../../../uq-ui/components/horizontal-switch";
import {createClassNames} from "../../../../../infrastructure/helpers";
import UQButton from "../../../../uq-ui/components/button";
import Icon from "../../../../icons/Icon";
import UiIcon from "../../../../uq-ui/components/ui-icon";
import {StickerCreateStepEnum} from "../../../domain/enums/StickerCreateStepEnum";
import Div100vh from "../../../../uq-ui/components/div-100";
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import StickersComponentsScannerHeader from "../../components/scanner-header";

class StickersScreensNewStickerTheme extends Component {

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-new-sctiker-theme');
    this.props.checkStepValidation(StickerCreateStepEnum.SelectTheme);
  }

  onBackPressed = () => {
    const {history, stickerId, stickerItemId} = this.props;
    history.push(`/${stickerId}/new/preview`);
  };

  onNextPressed = () => {
    const {stickerState, stickerId, history, stickerItemId} = this.props;
    cacheManager.cacheTheme(stickerState);
    history.push(`/stickers/${stickerId}/new/preview`);
  };

  onThemesGroupPressed = (group) => {
    this.props.setThemeGroup(group);
    this.props.setTextGroup(group);
  };

  onThemePressed = (theme) => {
    this.props.setTheme(theme);
  };

  isThemeSelected = (theme) => {
    return this.props.selectedTheme && this.props.selectedTheme.id === theme.id;
  };

  _renderThemeButton(theme, index) {
    const isSelected = this.isThemeSelected(theme);
    const themeBtnStyle = [styles.themeBtn];
    if (isSelected) {
      themeBtnStyle.push(styles.themeBtnSelected);
    }
    const themeBtnClass = createClassNames(themeBtnStyle);

    return (
      <div key={theme.id}
           onClick={() => this.onThemePressed(theme)}
           className={themeBtnClass}>
        {isSelected && (
          <div className={styles.themeBtnSelectedOverlay}>
            <UiIcon name="check" size={22} strokeWidth={2.6} color="#FFFFFF"/>
          </div>
        )}
        <img src={theme.preview.source.src}
             className={styles.themeBtnImg}/>
      </div>
    )
  }

  _renderActiveThemeImage() {
    const MAX_SIZE = 240;
    let targetSize = `${window.innerHeight * .35}px`;
    targetSize = targetSize > MAX_SIZE ? MAX_SIZE : targetSize;

    return (
      <div className={styles.activeTheme}>
        {this.props.selectedTheme && (
          <figure
            className={styles.activeThemeImage}
            style={{
              backgroundImage: `url(${this.props.selectedTheme.big.source.src})`
            }}/>
        )}
      </div>
    );
  }

  groupKeyExtractor = (item) => item.id;

  groupLabelExtractor = (item) => item.title[getTranslationLang()];

  render() {
    if (!this.props.selectedTheme) return (<div style={{backgroundColor: 'var(--c-bg)'}}></div>)
    const titles = this.props.selectedTheme.title;
    const themeTitle = titles[getTranslationLang()] || titles['en'];

    return (
      <Fragment>
        <StickersComponentsScannerHeader
          theme="brand"
          title={this.props.t('headerTitle')}
          showBackBtn={true}
          onBack={this.onBackPressed}/>
        <Div100vh className={styles.scrollView} style={{height: '100rvh'}}>
          <div className={styles.inner}>
            <div className={styles.header}>
              <div className={`${styles.title} font-title`}
                   dangerouslySetInnerHTML={{ __html: this.props.t('title') }}/>
            </div>

            {this.props.selectedTheme != null && this._renderActiveThemeImage()}

            <div className={styles.content}>
              {themeTitle && (<div className={styles.activeThemeTitle}>{themeTitle}</div>) }
            </div>

            <HorizontalSwitch
              contentContainerStyle={{ marginTop: '14px', paddingBottom: '12px' }}
              containerStyles={{ height: '52px', width: '100%', flex: '1 0 52px' }}
              items={this.props.themesGroups}
              onPress={this.onThemesGroupPressed}
              keyExtractor={this.groupKeyExtractor}
              labelExtractor={this.groupLabelExtractor}
              selectedItem={this.props.selectedGroup}/>

            {this.props.selectedGroup && (
              <div className={styles.themesScrollListWrap}>
                <div className={styles.themesScrollList}>
                  {this.props.activeGroupThemes.map((theme, index) => this._renderThemeButton(theme, index))}
                  <div className={styles.themesScrollListSpacer} />
                </div>
              </div>
            )}
          </div>

          <div className={styles.bottom}>
            <UQButton label={this.props.t('nextBtn')}
                      containerStyle={{ minWidth: 140 }}
                      theme={'brand'} onPress={this.onNextPressed}/>
          </div>
        </Div100vh>
      </Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    stickerState: createLlamaStateSelector(state),
    themesGroups: themesGroupsSelector(state),
    activeGroupThemes: createLlamaActiveGroupThemesSelector(state),
    selectedTheme: createLlamaActiveThemeSelector(state),
    selectedGroup: createLlamaActiveThemesGroupSelector(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum)),
    setTextGroup: (group) => dispatch(setTextTemplatesGroup(group)),
    setThemeGroup: (group) => dispatch(setThemeGroup(group)),
    setTheme: (theme) => dispatch(setTheme(theme))
  };
};

export default compose(
  withTranslation('scr-new-sticker-theme'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewStickerTheme);
